export enum FACTOR_TYPE {
  SUBSIDIZED = 'subsidized',
  LAST_VISIT = 'last_visit',
  IS_FIRST_VISIT = 'is_first_visit',
  HOLIDAY = 'holiday',
  SOLD_OUT = 'sold_out',
  WEATHER = 'weather',
  IS_BETTER_SALES_DAY_OF_WEEK = 'is_better_sales_day_of_week',
  SAME_LOCATION_EVENTS = 'same_location_events',
}
